import Vue from 'vue'
import App from './App.vue'
import store from './store'
// 适配低版本andorid 浏览器使用webrtc
import adapter from 'webrtc-adapter';

// import vConsole from 'vconsole'
Vue.config.productionTip = false
// Vue.prototype.$vConsole = new vConsole()


new Vue({
	el: '#app',
	store,
	render: h => h(App),
}).$mount('#app')
